import React, { useEffect, useState } from "react";
import PageTitle from "../../../shared/components/pagetitle";
import { PROFILE } from "../../../assets";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ButtonV2 from "../../../shared/components/buttonV2";
import { toast } from "react-hot-toast";
import { profileUpdate } from "../../../Services/auth";
import { selectUser, setUser } from "../../../states/slices/authReducer";
import { ProfileUpdateTypes } from "../../../types";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import clsx from "clsx";
import {
  JudicialDivision,
  LocalGovernment,
  PlatformCharge,
  States,
} from "./tabs";

function AdminSettings() {
  const [tab, setTab] = useState<"account" | "location">("account");

  const switchedTabs = () => {
    switch (tab) {
      case "account":
        return <AccountSettings />;

        break;

      case "location":
        return <Location />;

      default:
        return <AccountSettings />;
        break;
    }
  };
  return (
    <div className="p-3 sm:p-5">
      <PageTitle title="Settings" subtitle="Manage your account settings" />

      <div className="w-full sm:w-fit flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 p-3 bg-lightGold rounded-xl mt-4">
        <button
          onClick={() => setTab("account")}
          className={clsx(
            "w-full sm:w-fit px-5 py-2 text-xs text-[#656F7D] rounded-lg",
            tab === "account" && "text-globalGold shadow-blur bg-white",
          )}
        >
          Account Settings
        </button>
        <button
          onClick={() => setTab("location")}
          className={clsx(
            "w-full sm:w-fit px-5 py-2 text-xs text-[#656F7D] rounded-lg",
            tab === "location" && "text-globalGold shadow-blur bg-white",
          )}
        >
          Platform Settings
        </button>
      </div>

      <div>{switchedTabs()}</div>
    </div>
  );
}

export default AdminSettings;

export const AccountSettings = () => {
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowComfirmPassword] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formField, setFormField] = useState({
    name: "",
    dob: "",
    currentPassword: "",
    newpassword: "",
    confirmNewpassword: "",
  });

  const handleinputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormField((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getPasswordPayloads = () => {
    if (formField.newpassword && formField.confirmNewpassword) {
      return {
        current_password: formField.currentPassword,
        password: formField.newpassword,
        password_confirmation: formField.confirmNewpassword,
      };
    } else return null;
  };
  const handleSaveChanges = async () => {
    setSaving(true);
    const passwordPayload = getPasswordPayloads();

    const payload = {
      ...passwordPayload,
      name: formField.name,
      dob: formField.dob,
    };

    try {
      const response = await profileUpdate(payload);
      if (response) {
        toast.success(response?.message);
        dispatch(setUser(response?.data));
        if (
          formField.currentPassword &&
          formField.newpassword &&
          formField.confirmNewpassword
        ) {
          setFormField({
            ...formField,
            confirmNewpassword: "",
            newpassword: "",
            currentPassword: "",
          });
        }
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setSaving(false);
    }
  };
  useEffect(() => {
    if (user) {
      setFormField({ ...formField, name: user?.name, dob: user?.dob });
    }
  }, []);
  return (
    <div className="w-full flex flex-col lg:flex-row items-start gap-4 lg:gap-5 mt-4">
      <div className="w-full lg:w-[350px] flex-shrink-0 items-center justify-center flex flex-col gap-y-2 h-[256px] border border-[#E9EAEB] rounded-xl">
        <img
          src={PROFILE}
          className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px]"
          alt=""
        />
        <div className="flex flex-col gap-y-1 items-center px-2">
          <span className="text-base sm:text-lg font-semibold text-customDark text-center">
            {user?.name}
          </span>
          <span className="text-xs font-medium text-primary-50 text-center break-all">
            {user?.email}
          </span>
        </div>
        <div className="text-xs font-medium bg-[#F3FAF3] text-green-500 w-fit h-fit px-1.5 py-1">
          Active
        </div>
      </div>
      <div className="flex flex-col items-start gap-y-3 w-full">
        <div className="w-full border border-[#E9EAEB] rounded-xl">
          <div className="w-full py-3 px-2 bg-lightGold rounded-t-xl text-sm sm:text-[16px] font-semibold text-[#2A2E34]">
            Account Info
          </div>
          <div className="w-full flex flex-col sm:flex-row items-start gap-4 p-4">
            <div className="flex flex-col gap-y-2 w-full">
              <span className="text-[#4F5762] font-medium text-sm">
                Username
              </span>
              <div className="flex items-center gap-x-2 border border-borderColor rounded-lg p-2">
                <input
                  type="text"
                  name="name"
                  value={formField.name}
                  onChange={handleinputChange}
                  className="w-full outline-none bg-transparent text-sm"
                />
              </div>
            </div>
            <div className="flex flex-col gap-y-2 w-full">
              <span className="text-[#4F5762] font-medium text-sm">
                Date of Birth
              </span>
              <div className="flex items-center gap-x-2 border border-borderColor rounded-lg p-2">
                <input
                  type="date"
                  name="dob"
                  defaultValue={formField.dob}
                  onChange={handleinputChange}
                  className="w-full outline-none bg-transparent text-sm"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-full border border-[#E9EAEB] rounded-xl">
          <div className="w-full py-3 px-2 bg-lightGold rounded-t-xl text-sm sm:text-[16px] font-semibold text-[#2A2E34]">
            Password Management
          </div>
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 items-start gap-4 p-4">
            <div className="flex flex-col gap-y-2 w-full">
              <span className="text-[#4F5762] font-medium text-sm">
                Current Password
              </span>
              <div className="flex items-center gap-x-2 border border-borderColor rounded-lg p-2">
                <input
                  type={showCurrentPassword ? "text" : "password"}
                  placeholder="******************"
                  name="currentPassword"
                  value={formField.currentPassword}
                  onChange={handleinputChange}
                  className="w-full outline-none bg-transparent text-sm"
                />
                <span
                  className="cursor-pointer text-gray-500 flex-shrink-0"
                  onClick={() => setShowCurrentPassword((prev) => !prev)}
                >
                  {showCurrentPassword ? (
                    <FaEyeSlash size={16} />
                  ) : (
                    <FaEye size={16} />
                  )}
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-y-2 w-full">
              <span className="text-[#4F5762] font-medium text-sm">
                New Password
              </span>
              <div className="flex items-center gap-x-2 border border-borderColor rounded-lg p-2">
                <input
                  type={showNewPassword ? "text" : "password"}
                  placeholder="******************"
                  name="newpassword"
                  value={formField.newpassword}
                  onChange={handleinputChange}
                  className="w-full outline-none bg-transparent text-sm"
                />
                <span
                  className="cursor-pointer text-gray-500 flex-shrink-0"
                  onClick={() => setShowNewPassword((prev) => !prev)}
                >
                  {showNewPassword ? (
                    <FaEyeSlash size={16} />
                  ) : (
                    <FaEye size={16} />
                  )}
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-y-2 w-full lg:col-span-2">
              <span className="text-[#4F5762] font-medium text-sm">
                Confirm Password
              </span>
              <div className="flex items-center gap-x-2 border border-borderColor rounded-lg p-2">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="******************"
                  name="confirmNewpassword"
                  value={formField.confirmNewpassword}
                  onChange={handleinputChange}
                  className="w-full outline-none bg-transparent text-sm"
                />
                <span
                  className="cursor-pointer text-gray-500 flex-shrink-0"
                  onClick={() => setShowComfirmPassword((prev) => !prev)}
                >
                  {showConfirmPassword ? (
                    <FaEyeSlash size={16} />
                  ) : (
                    <FaEye size={16} />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex items-center justify-end">
          <ButtonV2
            title={"Save Changes"}
            loading={saving}
            loaderColor="#ffffff"
            btnStyle={"bg-globalGold w-fit h-fit px-3 py-2 rounded-lg"}
            textStyle={"text-sm font-medium text-white"}
            handleClick={handleSaveChanges}
          />
        </div>
      </div>
    </div>
  );
};

const tabs = [
  {
    label: "States",
    tab: "state",
  },
  {
    label: "Local Government",
    tab: "lg",
  },
  {
    label: "Judicial Divisions",
    tab: "jd",
  },
  {
    label: "Site Settings",
    tab: "pt",
  },
];
// Location component - make tabs responsive
export const Location = () => {
  const [activeTab, setActiveTab] = useState("state");

  const switchTabs = () => {
    switch (activeTab) {
      case "state":
        return <States />;
        break;
      case "lg":
        return <LocalGovernment />;
        break;
      case "jd":
        return <JudicialDivision />;
        break;
      case "pt":
        return <PlatformCharge />;
      default:
        return <States />;
        break;
    }
  };
  return (
    <div className="w-full border border-[#E9EAEB] rounded-xl mt-5">
      <div className="w-full py-3 px-4 bg-lightGold rounded-t-xl text-sm sm:text-[16px] font-semibold text-[#2A2E34]">
        Location Settings
      </div>

      <div className="w-full flex items-center gap-x-2 sm:gap-x-4 px-2 sm:px-4 border-b border-borderColor overflow-x-auto">
        {tabs.map((item) => (
          <button
            key={item.tab}
            onClick={() => setActiveTab(item.tab)}
            className={clsx(
              "text-[#656F7D] font-medium text-sm sm:text-[16px] p-2 whitespace-nowrap flex-shrink-0",
              item.tab === activeTab &&
                "border-b-2 border-globalGold text-globalGold",
            )}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="p-2 sm:p-4">{switchTabs()}</div>
    </div>
  );
};
